import { SxProps } from '@mui/material';

export const useStyles = () => {
  return {
    root: {
      '& .MuiBackdrop-root': {
        backgroundColor: 'transparent',
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: '520px',
      padding: '24px',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      gap: '16px',
      flexShrink: 0,
      position: 'relative',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '900px',
      background: 'rgba(3, 3, 3, 0.60)',
      backdropFilter: 'blur(15px)',
      borderRadius: '24px',
      maxWidth: '90vw',
      overflow: 'hidden',
      '&:focus-visible': {
        outline: 'none',
      },
      '@media (min-width: 1920px)': {
        width: '900px',
        height: '520px',
      },

      '@media (min-width: 1366px) and (max-width: 1919px)': {
        width: '900px',
        height: '520px',
      },

      '@media (min-width: 1024px) and (max-width: 1365px)': {
        width: '700px',
        height: '480px',
        padding: '20px',
        gap: '12px',
      },

      '@media (min-width: 768px) and (max-width: 1023px)': {
        width: '90vw',
        maxWidth: '550px',
        height: 'auto',
        maxHeight: '95vh',
        padding: '18px',
        borderRadius: '20px',
        gap: '0px',
      },

      '@media (max-width: 767px)': {
        width: '95vw',
        height: 'auto',
        minHeight: '380px',
        maxHeight: '95vh',
        padding: '16px',
        borderRadius: '16px',
        gap: '10px',
      },

      '@media (max-width: 480px)': {
        width: '98vw',
        padding: '14px',
        borderRadius: '12px',
        minHeight: '350px',
        gap: '8px',
      },
    } as SxProps,
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      width: '100%',
      minHeight: '28px',
      marginBottom: '8px',
      '@media (max-width: 1023px)': {
        minHeight: '24px',
        marginBottom: '6px',
      },
      '@media (max-width: 767px)': {
        minHeight: '20px',
        marginBottom: '4px',
        alignItems: 'center',
      },
    },
    formTitle: {
      color: '#FFF',
      fontFamily: 'Primary-Bold',
      fontSize: '32px',
      fontStyle: 'normal',
      lineHeight: '110%',
      textAlign: 'center',
      width: '100%',
      '@media (max-width: 1023px)': {
        fontSize: '24px',
      },
      '@media (max-width: 767px)': {
        fontSize: '20px',
      },
      '@media (max-width: 480px)': {
        fontSize: '18px',
      },
    },
    closeButton: {
      color: 'white',
      minWidth: 'auto',
      width: '32px',
      height: '32px',
      p: 0,
      borderRadius: '50%',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      flexShrink: 0,
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.25)',
        border: '1px solid rgba(255, 255, 255, 0.5)',
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '@media (max-width: 767px)': {
        width: '28px',
        height: '28px',
      },
      '@media (max-width: 480px)': {
        width: '24px',
        height: '24px',
      },
    },
    closeButtonText: {
      fontSize: '16px',
      fontWeight: 'bold',
      fontFamily: 'Noto Sans',
      '@media (max-width: 767px)': {
        fontSize: '14px',
      },
      '@media (max-width: 480px)': {
        fontSize: '12px',
      },
    },
    closeButtonAbsolute: {
      position: 'absolute',
      top: '16px',
      right: '24px',
      zIndex: 1,
    },
    questionHeader: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '12px',
      gap: '4px',
      '@media (max-width: 1023px)': {
        marginBottom: '8px',
        gap: '2px',
      },
      '@media (max-width: 767px)': {
        marginBottom: '6px',
        gap: '2px',
      },
      '@media (max-width: 480px)': {
        marginBottom: '4px',
        gap: '1px',
      },
    },
    stepIndicator: {
      color: '#FFF',
      fontFamily: '"Noto Sans"',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '140%',
      textAlign: 'left',
      width: '100%',
      flex: 1,
      '@media (max-width: 1023px)': {
        fontSize: '16px',
      },
      '@media (max-width: 767px)': {
        fontSize: '14px',
      },
      '@media (max-width: 480px)': {
        fontSize: '13px',
      },
    },
    questionSubtitle: {
      color: '#FFF',
      fontFamily: '"Noto Sans"',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 300,
      lineHeight: '140%',
      textAlign: 'left',
      width: '100%',
      '@media (max-width: 1023px)': {
        fontSize: '13px',
      },
      '@media (max-width: 767px)': {
        fontSize: '12px',
      },
      '@media (max-width: 480px)': {
        fontSize: '11px',
      },
    },
    questionContent: {
      width: '100%',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: '240px',
      marginBottom: '16px',
      '@media (max-width: 1023px)': {
        minHeight: 'auto',
        marginBottom: '14px',
      },
      '@media (max-width: 767px)': {
        marginBottom: '12px',
      },
      '@media (max-width: 480px)': {
        marginBottom: '10px',
      },
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      gap: '24px',
    },
    navigationButtons: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '16px',
      width: '100%',
      marginTop: 'auto',
      padding: '16px 0',
      '@media (max-width: 1023px)': {
        padding: '12px 0',
      },
      '@media (max-width: 767px)': {
        gap: '12px',
        flexDirection: 'column',
        padding: '10px 0',
      },
      '@media (max-width: 480px)': {
        gap: '8px',
        padding: '8px 0',
      },
    },
    previousButton: {
      backgroundColor: 'white',
      color: 'black',
      fontFamily: 'Noto Sans',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
      },
      width: '177px',
      height: '44px',
      padding: '0px 16px',
      borderRadius: '99px',
      textTransform: 'none',
      fontSize: '0.9rem',
      fontWeight: '500',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      '@media (max-width: 1023px)': {
        width: '160px',
        height: '40px',
        fontSize: '0.85rem',
      },
      '@media (max-width: 767px)': {
        width: '100%',
        maxWidth: '200px',
        height: '40px',
        fontSize: '0.8rem',
      },
      '@media (max-width: 480px)': {
        height: '36px',
        fontSize: '0.75rem',
        padding: '0px 12px',
      },
    },
    nextButton: {
      display: 'flex',
      width: '177px',
      height: '44px',
      padding: '0px 16px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      flexShrink: 0,
      borderRadius: '99px',
      backgroundColor: '#D71921',
      color: 'white',
      fontFamily: 'Noto Sans',
      textTransform: 'none',
      fontSize: '0.9rem',
      fontWeight: '500',
      border: 'none',
      '&:hover': {
        backgroundColor: '#b3141a',
      },
      '@media (max-width: 1023px)': {
        width: '160px',
        height: '40px',
        fontSize: '0.85rem',
      },
      '@media (max-width: 767px)': {
        width: '100%',
        maxWidth: '200px',
        height: '40px',
        fontSize: '0.8rem',
      },
      '@media (max-width: 480px)': {
        height: '36px',
        fontSize: '0.75rem',
        padding: '0px 12px',
      },
    },
    nextButtonDisabled: {
      backgroundColor: 'rgba(215, 25, 33, 0.3)',
      color: 'rgba(255, 255, 255, 0.5)',
      '&:hover': {
        backgroundColor: 'rgba(215, 25, 33, 0.3)',
      },
    },
    defaultQuestionText: {
      color: 'white',
      fontFamily: 'Noto Sans',
      opacity: 0.8,
    },
  };
};
